import { Box, Icon, ToastNotification, Typography } from "@drone-js/core";
import type { NotificationAction } from "@drone-js/core";
import type { FunctionComponent } from "react";
import { usePropertySelectionViewModelValue } from "../propertySelectionViewModelAtom";

interface Props {
    isOpen: boolean;
    title?: string;
    content?: string;
    actions?: [NotificationAction] | [NotificationAction, NotificationAction];
    onClose?: () => void;
}

export const ToastErrorNotification: FunctionComponent<Props> = ({ isOpen, title, content, actions, onClose }) => {
    const {
        inputUrlCms: { toastErrorTitle, toastErrorContent },
    } = usePropertySelectionViewModelValue();
    if (isOpen) {
        return (
            <Box position="fixed" maxWidth="288px" right="24px" bottom="102px" zIndex={999}>
                <ToastNotification
                    intent="error"
                    title={
                        <Box display="flex" alignItems="center">
                            <Icon id="fill.symbol.triangle-exclamation" me="8" size="20" color="feedback.negative" />
                            <Typography variant="body-s-strong">{title || toastErrorTitle}</Typography>
                        </Box>
                    }
                    description={
                        <Box ms="4">
                            <Typography variant="body-s" ms="24">
                                {content || toastErrorContent}
                            </Typography>
                        </Box>
                    }
                    dismissible
                    actions={actions}
                    onClose={onClose}
                />
            </Box>
        );
    }
    return null;
};
